import { render, staticRenderFns } from "./LegacyFirewallRules.vue?vue&type=template&id=2690565e&"
import script from "./LegacyFirewallRules.vue?vue&type=script&lang=js&"
export * from "./LegacyFirewallRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports